import { IconProps } from './Icon';

export const CloseIcon = ({ ...props }: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M12 12L28 28"
      stroke="#5E6A81"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 12L12 28"
      stroke="#5E6A81"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
